export default __webpack_public_path__ + "static/media/appcontrolreserva.d6c503e0.png";